module.exports = __webpack_public_path__ + "static/media/mongodblogo.4dae2a92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/mongodblogo.jpg
// module id = 832
// module chunks = 0